export const ROLES = {
  CLIENT: 'client',
  COMPANY: 'company_user',
  ADMIN: 'admin',
}
